import { HttpClient } from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnChanges,
  OnInit,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { environment } from "@environments/environment";

@Component({
    selector: "app-configure-filter",
    templateUrl: "./configure-filter.component.html",
    styleUrls: ["./configure-filter.component.scss"],
    standalone: false
})
export class ConfigureFilterComponent implements OnInit, OnChanges {
  public editForm!: UntypedFormGroup;
  field: any;
  auto: any;
  fieldData: any;
  fieldsHidden: boolean = false;
  message: string = "Are you sure?";
  private dataPointId!: number;
  name: string = "";
  type: string = "";
  typeEnding: string = "";
  typeBeginning: string = "";
  expressionName: string = "";
  public formFields: any[] = [];
  public displayRules: any;
  public filteredDisplayRules: any[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private cdRef: ChangeDetectorRef,
    private dialogRef: MatDialogRef<ConfigureFilterComponent>
  ) {
    if (data) {
      this.message = data.message || this.message;
      this.dataPointId = data.id;
      this.fieldData = data.field;
      this.auto = data.auto;
    }
  }

  formatLabel(value: number) {
    return value;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onConfirmClick(): void {
    if (this.editForm.valid) {
      Object.keys(this.editForm.controls).forEach((key, index) => {
        const displayType = this.field.filters.data[index].displayType;
        if (
          displayType == "toggle" ||
          displayType == "button-toggle" ||
          displayType == "checkbox"
        ) {
          this.field.filters.data[index].value = this.editForm
            .get(key)!
            .get("item")!.value;
        } else if (displayType == "daterange") {
          const start = this.editForm.get(key)?.get("start")?.value;
          const end = this.editForm.get(key)?.get("end")?.value;
          this.field.filters.data[index].value = {
            start: start ? this.toUtcIsoString(new Date(start), false) : null,
            end: end ? this.toUtcIsoString(new Date(end), true) : null,
          };
        } else if (displayType == "datepicker") {
          const date = this.editForm.get(key)?.value;
          let normalizedDate = date ? new Date(date) : null;
          this.field.filters.data[index].value = normalizedDate ? this.toUtcIsoString(normalizedDate, false) : null;
        } else if (displayType == "number") {
          this.field.filters.data[index].value = parseInt(
            this.editForm.get(key)!.value
          );
        } else {
          this.field.filters.data[index].value =
            this.editForm.get(key)!.value;
        }
      });
      let fieldDate: any[] = [];
      this.field.filters.data.forEach((element: any) => {
        if (element.showField) fieldDate.push(element);
      });
      this.field.filters.data = fieldDate;
      this.dialogRef.close(this.field);
    }
  }

  toUtcIsoString(date: Date, isEnd = false): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    if (isEnd) {
      return `${year}-${month}-${day}T23:59:59.999Z`;
    } else {
      return `${year}-${month}-${day}T00:00:00.000Z`;
    }
  }

  onCancelClick(): void {
    this.dialogRef.close(null);
  }

  getaDatPointConfig(id: number) {
    this.http
      .get(
        environment.enterpriseUrls.apiEndpoint +
          "/datapoints/" +
          id +
          "?include=filters,sorts,groups,displayRules"
      )
      .subscribe((suc: any) => {
        this.name = suc.data.name;
        this.type = suc.data.type;
        if (this.type == "updated" || this.type == "created") {
          this.type = "date";
        }
        this.formFields = suc.data.filters.data;
        this.displayRules = suc.data.displayRules.data;
        this.field = suc.data;

        this.formFields.forEach((element: any, index) => {
          if (index > 0) {
            element.showField = false;
          } else {
            element.showField = true;
          }
        });
        this.typeEnding = "Operator";
        this.typeBeginning = "filterBy";
        if (
          suc.data.filters &&
          suc.data.filters.data &&
          suc.data.filters.data.length > 0
        )
          this.expressionName = suc.data.filters.data[0].name;

        this.displayRules.forEach((element: any) => {
          if (element.if == this.expressionName) {
            this.filteredDisplayRules.push(element);
          }
        });
        this.generateForm();
      });
    // setTimeout(() => this.setFormValues(), 1000);
  }

  modifyConfigValues(event: any, name: string) {
    // reset all on change
    if (name == this.expressionName) {
      this.formFields.forEach((element: any, index) => {
        if (index > 0) {
          element.showField = false;
        } else {
          element.showField = true;
        }
      });
      this.showAssociatedFields(event.value);
    }
  }

  showAssociatedFields(val: any) {
    let fieldsToShow: any[] = [];
    this.filteredDisplayRules.forEach((element: any) => {
      if (element.containsAny.includes(val)) {
        fieldsToShow.push(element.show);
      }
    });

    this.formFields.forEach((element: any) => {
      if (fieldsToShow.includes(element.name)) {
        element.showField = true;
      } else {
        element.showField = false;
      }
    });

    this.formFields[0].showField = true;
  }

  // Parses a stored ISO date string ("YYYY-MM-DD" or "YYYY-MM-DDT00:00:00.000Z") into a
  // local-midnight Date object by extracting UTC calendar parts. This prevents dates stored as
  // midnight UTC from shifting backward one day in negative-offset timezones (e.g. America/New_York)
  // when passed directly to Angular Material's datepicker, which renders in local time.
  private parseDateFromIso(isoString: string): Date {
    const d = new Date(isoString);
    return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  }

  setFormValues() {
    if (this.fieldData.fields) {
      this.showAssociatedFields(this.fieldData.fields.data[0].value);
      this.fieldData.fields.data.forEach((element: any) => {
        if (element.value) {
          const ctrl = this.editForm.get(element.modifier.data.name);
          if (ctrl?.get?.('start') && ctrl?.get?.('end') && typeof element.value === 'object' && 'start' in element.value && 'end' in element.value) {
            // This is a date range FormGroup
            let start = element.value.start ? new Date(element.value.start) : null;
            let end = element.value.end ? new Date(element.value.end) : null;
            if (start) {
              // Use UTC date parts to avoid timezone shift (midnight UTC = prev day in UTC- zones)
              start = new Date(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate());
            }
            if (end) {
              // Use UTC date parts to avoid timezone shift for end date
              end = new Date(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate());
            }
            ctrl.get('start')?.setValue(start);
            ctrl.get('end')?.setValue(end);
          } else if (ctrl?.get?.('item')) {
            ctrl.get('item')!.setValue(element.value);
          } else {
            // For ISO date strings (datepicker values), extract UTC calendar date to prevent
            // timezone shift when the Angular Material datepicker renders in local time.
            const v = element.value;
            ctrl?.setValue(
              typeof v === 'string' && /^\d{4}-\d{2}-\d{2}/.test(v)
                ? this.parseDateFromIso(v)
                : v
            );
          }
        }
      });
    }

    if (this.fieldData.filters) {
      this.showAssociatedFields(this.fieldData.filters.data[0].value);
      this.fieldData.filters.data.forEach((element: any) => {
        if (element.value) {
          const ctrl = this.editForm.get(element.name);
            if (ctrl?.get?.('start') && ctrl?.get?.('end') && typeof element.value === 'object' && 'start' in element.value && 'end' in element.value) {
              // This is a date range FormGroup
              let start = element.value.start ? new Date(element.value.start) : null;
              let end = element.value.end ? new Date(element.value.end) : null;
              if (start) {
                // Use UTC date parts to avoid timezone shift (midnight UTC = prev day in UTC- zones)
                start = new Date(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate());
              }
              if (end) {
                // Use UTC date parts to avoid timezone shift for end date
                end = new Date(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate());
              }
              ctrl.get('start')?.setValue(start);
              ctrl.get('end')?.setValue(end);
            } else if (ctrl?.get?.('item')) {
              ctrl.get('item')!.setValue(element.value);
            } else {
              // For ISO date strings (datepicker values), extract UTC calendar date to prevent
              // timezone shift when the Angular Material datepicker renders in local time.
              const v = element.value;
              ctrl?.setValue(
                typeof v === 'string' && /^\d{4}-\d{2}-\d{2}/.test(v)
                  ? this.parseDateFromIso(v)
                  : v
              );
            }
        }
      });
    }
  }

  generateField(field: any) {
    switch (field.displayType) {
      case "button-toggle":
      case "toggle":
      case "checkbox":
        if (field.value) {
          this.editForm.addControl(
            field.name,
            this.fb.group({
              item: new UntypedFormControl(field.value),
            })
          );
        } else {
          this.editForm.addControl(
            field.name,
            this.fb.group({
              item: new UntypedFormControl(field.default.data.value),
            })
          );
        }
        break;
      case "daterange":
        this.editForm.addControl(
          field.name,
          this.fb.group({
            start: new UntypedFormControl(),
            end: new UntypedFormControl(),
          })
        );
        break;
      case "datepicker":
        this.editForm.addControl(
          field.name,
          new UntypedFormControl(new Date())
        );
        break;
      default:
        this.editForm.addControl(field.name, this.fb.control(field.value));
    }
  }

  generateForm() {
    let forEachPromise = new Promise<void>((resolve) => {
      this.formFields.forEach((field, index, array) => {
        this.generateField(field);
        if (index === array.length - 1) resolve();
      });
    });

    forEachPromise.then(() => {
      this.setFormValues();
    });
  }

  ngOnChanges() {
    this.cdRef.markForCheck();
    this.cdRef.detectChanges();
  }

  ngOnInit(): void {
    this.editForm = this.fb.group({});
    this.getaDatPointConfig(this.dataPointId);
  }
}
